exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.td-dragable {\n  display: table-row;\n  width: 100%;\n  /*background-color: #1e7e34;*/\n}\n\n.td-dragable td {\n  padding: 0.75rem;\n  vertical-align: top;\n  display: table-cell;\n\n  border-top: 0;\n  border-right: 0;\n  border-left: 0;\n  border-bottom: solid 2px #eeeeee !important;\n}\n\n.td-dragable td .fa-ellipsis-v{\n  color: #d8d8d8;\n}\n\n.td-dragable td img {\n  max-height: 65px;\n  max-width: 65px;\n  border: solid 1px #dadada;\n}\n\n.td-dragable td a {\n  color: #4a4a4a;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/ordenar-productos/ordenar-productos.component.css
// module id = ../../../../../src/app/pages/admin/ordenar-productos/ordenar-productos.component.css
// module chunks = main